import React, { useState, useEffect } from "react";
import { DataStore } from "@aws-amplify/datastore";
import { Card } from "react-bootstrap";
import { VehicleModelGeneralInfo } from "../models";

function Suggestions({ suggestions, onSuggestionSelect }) {
    return (
        <div className="disappear card mx-auto d-flex flex-column justify-content-between">
            {suggestions.map((suggestion, index) => (
                <div
                    key={index}
                    className="suggestion-item"
                    onClick={() => onSuggestionSelect(suggestion)}
                >
                    {suggestion.Manufacturer} {suggestion.ModelName}
                </div>
            ))}
        </div>
    );
}

export default function Trucks() {
    const [trucks, setTrucks] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [selectedTruck, setSelectedTruck] = useState(null);
    const [filteredSuggestions, setFilteredSuggestions] = useState([]);

    useEffect(() => {
        const searchInput = document.querySelector(".search-input");
        const suggestionsList = document.querySelector(".disappear");

        function handleClickOutside(event) {
            if (searchInput && !searchInput.contains(event.target) && suggestionsList && !suggestionsList.contains(event.target)) {
                setFilteredSuggestions([]);
            }
        }

        document.addEventListener("click", handleClickOutside);
        return () => {
            document.removeEventListener("click", handleClickOutside);
        };
    }, []);

    useEffect(() => {
        fetchTrucks();
    }, []);

    async function fetchTrucks() {
        try {
            const fetchedTrucks = await DataStore.query(VehicleModelGeneralInfo);
            setTrucks(fetchedTrucks);
        } catch (error) {
            console.error("Error fetching trucks:", error);
        }
    }

    function filterTrucks(truck, searchQuery) {
        const words = searchQuery.toLowerCase().split(" ");
        return (
            truck.VehicleType === "TRUCK" &&
            truck.Manufacturer &&
            truck.ModelName &&
            words.every(
                (word) =>
                    truck.Manufacturer.toLowerCase().includes(word) ||
                    truck.ModelName.toLowerCase().includes(word)
            )
        );
    }

    function handleInputChange(event) {
        const query = event.target.value;
        setSearchQuery(query);
        const suggestions = trucks.filter((truck) => filterTrucks(truck, query));
        setFilteredSuggestions(suggestions);
    }

    function handleSuggestionSelect(suggestion) {
        setSelectedTruck(suggestion);
        setFilteredSuggestions([]); // Clear suggestions
    }

    function toggleSuggestions() {
        if (filteredSuggestions.length > 0) {
            setFilteredSuggestions([]);
        } else {
            const trucksOnly = trucks.filter(truck => truck.VehicleType === "TRUCK");
            setFilteredSuggestions(trucksOnly);
        }
    }

    return (
        <div style={{ position: "relative" }}>
            <div style={{ display: "flex", flexDirection: "column" }}>
                <input
                    className="search-input card mx-auto d-flex flex-column justify-content-between"
                    type="text"
                    placeholder="Click here to see trucks or search truck models..."
                    value={searchQuery}
                    onChange={handleInputChange}
                    onClick={toggleSuggestions}
                    style={{ padding: "10px", marginBottom: "5px" }}
                />

                {filteredSuggestions.length > 0 && (
                    <Suggestions
                        suggestions={filteredSuggestions}
                        onSuggestionSelect={handleSuggestionSelect}
                    />
                )}
            </div>

            {selectedTruck && (
                <div className="homepageCarousel">
                    <Card className="card mx-auto d-flex flex-column justify-content-between">
                        <div>
                            <Card.Img
                                variant="top"
                                src={selectedTruck.Picture}
                                alt={`Slide Truck`}
                            />
                            <Card.Body className="card-body"
                                style={{ maxHeight: "400px", overflowY: "auto" }}>
                                <Card.Text>Manufacturer: {selectedTruck.Manufacturer}</Card.Text>
                                <Card.Text>Model Name: {selectedTruck.ModelName}</Card.Text>
                                <Card.Text>Model Year: {selectedTruck.ModelYear}</Card.Text>
                                <Card.Text>Body Style: {selectedTruck.BodyStyle}</Card.Text>
                                <Card.Text>Engine Type: {selectedTruck.EngineType}</Card.Text>
                                <Card.Text>Fuel Type: {selectedTruck.FuelType}</Card.Text>
                                <Card.Text>Transmission: {selectedTruck.Transmission}</Card.Text>
                                <Card.Text>Drivetrain: {selectedTruck.Drivetrain}</Card.Text>
                                <Card.Text>Acceleration: {selectedTruck.Acceleration}</Card.Text>
                                <Card.Text>Top Speed: {selectedTruck.TopSpeed}</Card.Text>
                                <Card.Text>Fuel Economy: {selectedTruck.FuelEconomy}</Card.Text>
                                <Card.Text>Cargo Space: {selectedTruck.CargoSpace}</Card.Text>
                                <Card.Text>Seating Capacity: {selectedTruck.SeatingCapacity}</Card.Text>
                                <Card.Text>Dimensions: {selectedTruck.Dimensions}</Card.Text>
                                <Card.Text>Weight: {selectedTruck.Weight}</Card.Text>
                                <Card.Text>Tire Size: {selectedTruck.TireSize}</Card.Text>
                                <Card.Text>Country Of Origin: {selectedTruck.CountryOfOrigin}</Card.Text>
                                <Card.Text>Price: {selectedTruck.Price}</Card.Text>
                                <Card.Text>Warranty: {selectedTruck.Warranty}</Card.Text>
                                <Card.Text>Information: {selectedTruck.Information}</Card.Text>
                            </Card.Body>


                        </div>
                    </Card>
                </div>
            )}
        </div>
    );
}

